import { Button } from '@mui/material';
import { PANEL_MODES } from './state/reducer';
import React from 'react';
import ThinkingIndicator from './components/ChatThread/components/ThinkingIndicator';
import { translate } from '/b2b/common/helpers/i18n';
import useAIAssistant from './useAIAssistant';

/*
 * Top-bar entry point for the AI Assistant. A default outlined button showing the
 * Osano mark and product name that toggles the side panel open and closed. Styling
 * comes entirely from the theme so MUI theme changes propagate automatically. The
 * host decides whether to render this at all (flag + capability gate), so this
 * component itself is unconditional and just drives panelMode.
 */
const AIAssistantLauncher = () => {
    const { panelMode, setPanelMode } = useAIAssistant();
    const isOpen = panelMode === PANEL_MODES.SIDEBAR;

    const handleToggle = () => setPanelMode(isOpen ? PANEL_MODES.COLLAPSED : PANEL_MODES.SIDEBAR);

    return (
        <Button
            variant="outlined"
            color="tertiary"
            onClick={handleToggle}
            aria-pressed={isOpen}
            startIcon={<ThinkingIndicator size={20} />}
            // Keep the tertiary (dark) label but soften the outline to the neutral
            // border grey instead of the default tertiary-derived border, on rest
            // and hover alike.
            sx={{
                borderColor: theme => theme.palette.border,
                '&:hover': { borderColor: theme => theme.palette.border },
            }}
        >
            {translate('aiAssistant.name')}
        </Button>
    );
};

export default AIAssistantLauncher;
